const { FsmObject } = require('./object');

class FsmEvent extends FsmObject {
}

module.exports.FsmEvent = FsmEvent;
